import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../Actions/Config'
import AOS from "aos";
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import TourListing from "./Common/TourListing"
import { getAllSpecialTours } from "../Actions/HomeAction"
import "aos/dist/aos.css";

const mapStateToProps = (state) => {
    return {
        tour: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getAllSpecialTours: () => dispatch(getAllSpecialTours())
});


function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Day tour":
            url = "/day-tours/" + tour.permalink + "/" + tour.id
            break;
        case "Round tour":
            url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + tour.permalink
            break;

        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Day tour":
            image = tour.listing_image != undefined && tour.listing_image != '' ? tour.listing_image : API_URL + tour.banner_image
            break;
        case "Round tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.itinerary_images.thumb
            break;
        case "Maldive tour":
            image = tour.home_image.thumb
            break;
        default:
            break;
    }
    return image
}

class SpecialTourPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        }
        this.props.getAllSpecialTours()
    }

    componentDidMount() {
        AOS.init({
            duration: 800,
            once: true
        });
    }

    render() {

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />

            <div className="page-title">
                <div className="container title-cont">
                    <div className="row">
                        <div className="col-lg-12 title-inner">
                            <div className="breadcrumb-links">
                                <a href="/">Home</a>   <span className="sep"></span> Special Tours
                            </div>
                            <h1 id="tour-title">Special Discount Tours</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div id="loadDayTour" style={{ backgroundColor: "#f8f8f8", minHeight:"60vh" }}>
                <div id="myDiv">
                    <div className="maindiv" >
                        <div className="container">
                            <h2 style={{fontSize:30,color:"#175480",fontWeight:600,margin:"0 0 15px 15px;",paddingTop:15}}> Day Tours </h2>
                            <div className="row day-tour-row">

                                {this.props.tour.spDayTours.length > 0 ? this.props.tour.spDayTours.map((tour, index) => (<TourListing
                                    {...this.props}
                                    index={index}
                                    url={getURL(tour)}
                                    bgImage={getBackgroudImage(tour)}
                                    tour={tour}
                                    key={index + 1}
                                />))
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>

                
                <div id="myDiv">
                    <div className="maindiv" >
                        <div className="container">
                            <h2 style={{fontSize:30,color:"#175480",fontWeight:600,margin:"0 0 15px 15px;",paddingTop:15}}> Round Tours </h2>
                            <div className="row day-tour-row">

                                {this.props.tour.SpRoundTours.length > 0 ? this.props.tour.SpRoundTours.map((tour, index) => (<TourListing
                                    {...this.props}
                                    index={index}
                                    url={getURL(tour)}
                                    bgImage={getBackgroudImage(tour)}
                                    tour={tour}
                                    key={index + 1}
                                />))
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <Footer hyperLink={false}/>
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(SpecialTourPage);
